export default __webpack_public_path__ + "static/media/indiecita.b858e99d.png";